import { createRouter, createWebHistory } from "vue-router";

import Callback from "@/Callback.vue";
import ClaimRoutes from "@/claims/routes";
import TelematicsRoutes from "@/telematics/routes";

function getAnonymousRoutes(routes) {
  return routes.map((route) => {
    if (route.children) {
      return {
        ...route,
        children: getAnonymousRoutes(route.children || []),
        meta: { ...(route.meta || {}), allowAnonymous: true },
      };
    }
    return {
      ...route,
      name: route.name,
      meta: { ...(route.meta || {}), allowAnonymous: true },
    };
  });
}

function prefixRouteNames(routes, prefix) {
  return routes.map((route) => {
    if (route.children) {
      return {
        ...route,
        name: `${prefix}/${route.name}`,
        children: prefixRouteNames(route.children || [], prefix),
      };
    }
    return {
      ...route,
      name: `${prefix}/${route.name}`,
    };
  });
}

const routes = [
  {
    name: "Callback",
    path: "/redirect",
    component: Callback,
  },
  ...prefixRouteNames(getAnonymousRoutes(ClaimRoutes), "Claims"),
  ...prefixRouteNames(getAnonymousRoutes(TelematicsRoutes), "Telematics"),
];

export default createRouter({
  history: createWebHistory(),
  routes,
});
